import React from 'react';
import { useSwitchToTargetChain } from '../../hooks/useSwitchToTargetChain';

const SwitchNetworkButton = ({ className = '' }) => {
    const {
        switchToTargetChain,
        addTargetChain,
        needsAddNetwork,
        isPending,
        errorMessage,
        displayChainName,
    } = useSwitchToTargetChain();

    const handleSwitch = () => {
        switchToTargetChain().catch(() => {});
    };

    const handleAdd = () => {
        addTargetChain().catch(() => {});
    };

    return (
        <div className={`flex flex-col items-center gap-3 ${className}`}>
            <div className="flex flex-wrap items-center justify-center gap-2">
                <button
                    type="button"
                    onClick={handleSwitch}
                    disabled={isPending}
                    className="rounded-2xl bg-amber-500 px-6 py-3 text-sm font-semibold text-slate-950 transition hover:bg-amber-400 disabled:opacity-60"
                >
                    {isPending
                        ? 'Updating network…'
                        : `Switch to ${displayChainName}`}
                </button>
                <button
                    type="button"
                    onClick={handleAdd}
                    disabled={isPending}
                    className="rounded-2xl border border-amber-300 bg-amber-50 px-5 py-3 text-sm font-semibold text-amber-950 transition hover:bg-amber-100 disabled:opacity-60 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-100 dark:hover:bg-amber-950/70"
                >
                    Add {displayChainName}
                </button>
            </div>

            {needsAddNetwork ? (
                <p className="max-w-sm text-center text-xs text-amber-800 dark:text-amber-200/90">
                    {displayChainName} is not in your wallet yet. Use{' '}
                    <span className="font-semibold">Add {displayChainName}</span>, then
                    switch network.
                </p>
            ) : (
                <p className="max-w-sm text-center text-xs text-zinc-500 dark:text-zinc-400">
                    Network missing from your wallet? Add {displayChainName} first, then
                    switch.
                </p>
            )}

            {errorMessage ? (
                <p className="max-w-sm text-center text-xs text-red-600 dark:text-red-400">
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
};

export default SwitchNetworkButton;
